/**
 * @generated SignedSource<<e1530c2454863ed4f9cd23a26a5dacc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type messageWithToolReferences_message$data = {
  readonly content: string;
  readonly id: string;
  readonly messageMetadata: {
    readonly agentVersion: string | null | undefined;
    readonly memoryAttributions: ReadonlyArray<{
      readonly influenceReason: string;
      readonly memoryBody: {
        readonly __typename: "GraphQLGenericLearningBody";
        readonly knowledge: string | null | undefined;
        readonly reasoning: string | null | undefined;
        readonly scope: string | null | undefined;
        readonly type: string | null | undefined;
      } | {
        readonly __typename: "GraphQLQueryBody";
        readonly query: any;
        readonly queryDescription: string | null | undefined;
        readonly queryType: string | null | undefined;
        readonly question: string | null | undefined;
      } | {
        readonly __typename: "GraphQLResourceBody";
        readonly content: any;
        readonly name: string;
        readonly resourceType: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly memoryId: string;
      readonly memorySummary: string;
      readonly memoryType: string;
      readonly source: string;
      readonly sourceType: string;
      readonly status: string;
      readonly taskContexts: ReadonlyArray<string>;
    }> | null | undefined;
    readonly sources: ReadonlyArray<{
      readonly artifactId: string | null | undefined;
      readonly description: string | null | undefined;
      readonly displayText: string;
      readonly groupTags: ReadonlyArray<string> | null | undefined;
      readonly link: string | null | undefined;
      readonly query: any | null | undefined;
      readonly title: string | null | undefined;
      readonly toolId: string | null | undefined;
      readonly type: string | null | undefined;
    }> | null | undefined;
    readonly usage: {
      readonly billingTokens: number;
    } | null | undefined;
  } | null | undefined;
  readonly output: string | null | undefined;
  readonly " $fragmentType": "messageWithToolReferences_message";
};
export type messageWithToolReferences_message$key = {
  readonly " $data"?: messageWithToolReferences_message$data;
  readonly " $fragmentSpreads": FragmentRefs<"messageWithToolReferences_message">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "query",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "messageWithToolReferences_message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "output",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageMetadata",
      "kind": "LinkedField",
      "name": "messageMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agentVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLIntegrationQuerySource",
          "kind": "LinkedField",
          "name": "sources",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "toolId",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "artifactId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "groupTags",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayText",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLUsageTokens",
          "kind": "LinkedField",
          "name": "usage",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billingTokens",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLMemoryAttribution",
          "kind": "LinkedField",
          "name": "memoryAttributions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "memoryId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "memoryType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "memoryBody",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scope",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "knowledge",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reasoning",
                      "storageKey": null
                    }
                  ],
                  "type": "GraphQLGenericLearningBody",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "queryType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "question",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "queryDescription",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "type": "GraphQLQueryBody",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "resourceType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    (v0/*: any*/)
                  ],
                  "type": "GraphQLResourceBody",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "source",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourceType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "influenceReason",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "memorySummary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taskContexts",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLFormattedMessage",
  "abstractKey": null
};
})();

(node as any).hash = "39ca7aec129fe97586867c0000eb848e";

export default node;
